import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMOnboardingEvents, OnboardingSteps } from 'src/app/model/google-tag-manager/api-status';

@Component({
  selector: 'app-password-setup',
  templateUrl: './password-setup.component.html',
  styleUrls: ['./password-setup.component.scss']
})
export class PasswordSetupComponent implements OnInit {
  @Output() public passwordChanged: EventEmitter<{ password: string, mobileNumber: string }> = new EventEmitter();

  passwordForm = new FormGroup({
    mobileNumber: new CustomFormControl(),
  });
  mobileNumberControl: UntypedFormControl = this.passwordForm.get('mobileNumber') as UntypedFormControl;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    public resourceService: ADPResourceService,
  ) {
  }

  ngOnInit(): void {
    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.InProcess, OnboardingSteps.CreatePassword);
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.passwordForm.valid && this.passwordForm.controls['password']) {
      this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.CreatePassword);
      this.passwordChanged.emit({
        password: this.passwordForm.controls['password'].value,
        mobileNumber: this.mobileNumberControl.value
      });
    }
  }

  onClose() {
    this.router.navigate(['/login'], { queryParamsHandling: 'preserve' }).then(() => {
      window.location.reload();
    });
  }
}
